module.exports = __webpack_public_path__ + "static/media/BoxPlotQ5_5.6579b61a.svg";